import { render, staticRenderFns } from "./view5.vue?vue&type=template&id=cd7fb82e&scoped=true&"
import script from "./view5.vue?vue&type=script&lang=js&"
export * from "./view5.vue?vue&type=script&lang=js&"
import style0 from "./view5.vue?vue&type=style&index=0&id=cd7fb82e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7fb82e",
  null
  
)

export default component.exports